// questionersanswers document keys (#124). The questionnaire is refilled
// monthly, so a response is keyed by its Riyadh calendar month:
// `${userId}_${questionnaireId}_${YYYY-MM}`. Older documents are keyed by
// quarter (`..._2026-Q3`); readers never rely on the key — they take the
// newest row by completedAt — so both shapes keep working side by side.
//
// Pure and import-free. namat-mobile writes the same key from
// src/lib/questionnaires/answerPeriod.ts (fixed UTC+3; Riyadh has no DST).
// Change both together.

export const RESPONSE_TIME_ZONE = 'Asia/Riyadh';

/** `YYYY-MM` of a moment in Riyadh (the month a 21:30 UTC fill on the 31st belongs to there). */
export function responseMonthId(date: Date, timeZone: string = RESPONSE_TIME_ZONE): string {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit' }).formatToParts(date);
  const year = parts.find((p) => p.type === 'year')!.value;
  const month = parts.find((p) => p.type === 'month')!.value;
  return `${year}-${month}`;
}

/** The questionersanswers document id for a response filled at `date`. */
export function responseDocId(userId: string, questionnaireId: string, date: Date): string {
  return `${userId}_${questionnaireId}_${responseMonthId(date)}`;
}

/** The `YYYY-MM` before a `YYYY-MM`. */
export function previousMonthId(monthId: string): string {
  const [y, m] = monthId.split('-').map(Number);
  return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, '0')}`;
}

/** True when `earlier` falls in the Riyadh month just before `later`'s. */
export function isPreviousMonth(earlier: Date, later: Date): boolean {
  return responseMonthId(earlier) === previousMonthId(responseMonthId(later));
}
